/**
 * @author Afif Hosseini <https://www.ahdesign.website/>
 * @license https://www.gnu.org/licenses/gpl-2.0.html
 * @link https://www.ahdesign.website
 */
export default function progressBar() {
	// eslint-disable-next-line camelcase, no-undef
	const hasProgressBar = preslav_customizer_object.progress_bar;

	if ( ! hasProgressBar || document.body.className.indexOf( 'single' ) == -1 ) {
		return;
	}
	const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
	// exclude site footer from the calculation
	const footer = document.getElementsByClassName( 'site-footer' )[ 0 ];
	const height = document.documentElement.scrollHeight - document.documentElement.clientHeight - footer.offsetHeight;
	const scrolled = ( winScroll / height ) * 100;
	document.getElementById( 'progressBar' ).style.width = scrolled + '%';
}
